
<template>
  <v-layout>
    <v-flex offset-xs3 xs6>
      <v-progress-linear :value="progress" height="5" color="accent"></v-progress-linear>
    </v-flex>
    <v-flex class="pb-0 pt-2 mt-2" xs1 text-xs-left>
      <span class="accent--text">{{progress}}%</span>
    </v-flex>
  </v-layout>
</template>

<script>
import { globalStore } from "../main";
import { eventBus } from "../main";
export default {
  computed: {
    totalPages() {
      return globalStore.totalPages
    },
    basePage() {
      return globalStore.basePage
    },
    progress() {
      var thisPgProgress = Math.round(
        (100 * this.pages.indexOf(this.value)) / (this.pages.length - 1)
      );
      var parentProgress = this.$parent.progress ? this.$parent.progress : 0;
      var maxProgress = Math.max(thisPgProgress, parentProgress);
      this.$parent.progress = maxProgress;
      return maxProgress;
    },
    pages() {
      return Array.from(Array(this.totalPages).keys()).map(i => this.basePage + (i + 1));
    }
  },
  props: ["value"],
  name: "lesson_progress",
  data() {
    return {
    };
  }
};
</script>
